import { Container, Stack, FormCheck } from "react-bootstrap";
import cn from "classnames";
import JobSearchCore from "@sourceflow-uk/job-search";
import JobType from "@/../.sourceflow/jobs-contract_type.json";
import Location from "@/../.sourceflow/jobs-Location.json";
import Sectors from "@/../.sourceflow/jobs-Sectors.json";
import Consultants from "@/../.sourceflow/jobs-Consultants.json";
import { JobCard } from "@/components";
import Search from "@/assets/Search.svg";
import styles from "./styles.module.scss";

export const JobSearch = ({
  jobsUrl,
  queryInput,
  locationInput,
  showResetSearchButton,
  topLevelCategoryOrder,
  resultsTitleText,
  resultsButtonText,
  inputPlaceholderText,
  buttonContent,
  className,
}) => {
  return (
    <section className={cn(styles.JobSearch, className)}>
      <Container>
        <JobSearchCore
          options={{
            jobsUrl,
            urlFilters: {
              mode: "active",
              jobCategories: [Sectors, Location, JobType, Consultants],
              changeURLOnFilterChange: true,
            },
            searchInput: {
              queryInput,
              locationInput,
            },
            searchFiltersOptions: {
              showResetSearchButton,
              topLevelCategoryOrder,
              categorySort: {
                Sectors: { key: "name", direction: "asc" },
              },
              exclude: { Consultants: true },
              filterUnselectedElement: <FormCheck />,
              filterSelectedElement: <FormCheck checked />,
            },
            searchResults: ({ results }) =>
              results && (
                <div className={styles.list}>
                  {results.map((job, index) => (
                    <div key={index} className="list-item">
                      <JobCard item={job.job} />
                    </div>
                  ))}
                </div>
              ),
          }}
          translations={{
            "filters.toggleButtonText": "",
            "searchResults.resultsTotalCount": resultsTitleText,
            "searchResults.buttonText": resultsButtonText,
            "input.placeHolder": inputPlaceholderText,
            "button.text": (
              <Stack
                className="flex-row align-items-center justify-content-center px-3"
                gap={2}
                data-sourceflow-prop="buttonContent"
              >
                <div dangerouslySetInnerHTML={{ __html: buttonContent }} />
              </Stack>
            ),
          }}
        />
      </Container>
    </section>
  );
};

export default JobSearch;
